import { ERROR_FAILED_TO_SELECT_SOURCE, QRULES_ERROR_NAME } from "../constants/errors";
import { paramDsNameSrc, paramXPathSrc } from '../constants/parameterNames';
import { typeXPath, typeDataSource, typeOption } from '../constants/parameterTypes';
import { getValidNode } from "../helpers/qRules.node.helpers";
import { getDataSource } from "../helpers/qRules.dataSource.helpers";
import { getParamValue } from "../helpers/parameter.accessors";

const paramCase = 'case';

const optionalParameters = [
    {
        name: paramDsNameSrc,
        description: 'Data Source Name for source',
        type: typeDataSource
    },
    {
        name: paramCase,
        description: 'Upper|Lower|Title (default is Upper)',
        type: typeOption,
        options: [
            {
                name: "Upper",
                value: "Upper"
            },
            {
                name: "Lower",
                value: "Lower"
            },
            {
                name: "Title",
                value: "Title"
            },
        ],
    },
];

const requiredParameters = [
    {
        name: paramXPathSrc,
        description: 'XPath for source field',
        type: typeXPath,
        dsParentName: paramDsNameSrc
    },
];

const description = "Returns a string with the value of the source node in the case requested. Options are Lower, Upper and Title. Title case sets all words to lower case, then sets the first letter to each to upper case unless the word is in all upper case already.";

function execute({ dataSources, parameters }) {
    const dsNameSrc = getParamValue(parameters, paramDsNameSrc);
    const xPathSrc = getParamValue(parameters, paramXPathSrc);
    const caseToSet = getParamValue(parameters, paramCase, 'Upper');

    const dataSource = getDataSource(dataSources, dsNameSrc);
    const sourceNode = getValidNode(dataSource, xPathSrc, ERROR_FAILED_TO_SELECT_SOURCE);

    try {
        const nodeValue = sourceNode.value();

        switch (caseToSet) {
            case "Upper":
                return nodeValue.toLocaleUpperCase();

            case "Lower":
                return nodeValue.toLocaleLowerCase();

            case "Title": {
                let errorObj = new Error('Title case is not supported in this version of qRules');
                errorObj.name = QRULES_ERROR_NAME;

                throw errorObj;
            }

            default: {
                let errorObj = new Error(`Invalid /${paramCase} value: ${caseToSet}`);
                errorObj.name = QRULES_ERROR_NAME;

                throw errorObj;
            }
        }
    } catch (e) {
        if (e.name === QRULES_ERROR_NAME) {
            throw e;
        }

        throw new Error(`Failed to set to ${caseToSet} case.`);
    }
}

const SetCase = {
    description,
    execute,
    optionalParameters,
    requiredParameters,
};

export default SetCase;